module.exports = __webpack_public_path__ + "static/img/321.0d70eda2.png";